export enum PropertyDiscriminator {
  DBListPropertyDTO = 'DBListPropertyDTO',
  ListPropertyDTO = 'ListPropertyDTO',
  ListEnumDTO = 'ListEnumDTO',
  StringPropertyDTO = 'StringPropertyDTO',
  IntPropertyDTO = 'IntPropertyDTO',
  DoublePropertyDTO = 'DoublePropertyDTO',
  LongPropertyDTO = 'LongPropertyDTO',
  FloatPropertyDTO = 'FloatPropertyDTO',
  BooleanPropertyDTO = 'BooleanPropertyDTO',
  ColorPropertyDTO = 'ColorPropertyDTO',
}
